module.exports = __webpack_public_path__ + "img/vrmol.ff8e3b36.png";